import { AiChatContext as e } from "../context/AiChatContext.mjs";
import { useContext as t, useEffect as n } from "react";
import { AiPageKind as r } from "@maat/api-ai/types";
//#region src/hooks/usePublishAiBookingPage.ts
var i = ({ bookingId: i, title: a }) => {
	let o = t(e)?.publishPage;
	n(() => {
		if (!(!o || !i || !a)) return o({
			title: a,
			context: {
				kind: r.Booking,
				bookingId: i
			}
		});
	}, [
		o,
		i,
		a
	]);
};
//#endregion
export { i as usePublishAiBookingPage };
